import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import _taggedTemplateLiteral from "@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  ", " {\n    ", " {\n      padding: 0 24px 0 0;\n\n      &.", "nav-item.", "menu-item.", "disabled {\n        color: #c1c1c1;\n\n        &:hover {\n          color: #c1c1c1;\n        }\n      }\n\n      .", "menu-item-inner {\n        height: 32px;\n        line-height: 32px;\n      }\n    }\n\n    ", " {\n      .", "nav-item.", "menu-item {\n        padding: 0 24px 0 0;\n\n        &.", "opened {\n          color: #555555;\n        }\n\n        .", "menu-icon-arrow.", "icon:before {\n          transform: scale(0.7);\n        }\n\n        .", "menu-item-inner {\n          height: 32px;\n          line-height: 32px;\n        }\n      }\n\n      .", "menu-sub-menu {\n        ", " {\n          padding: 0 24px 0 16px;\n\n          .", "menu-item-inner {\n            height: 32px;\n            line-height: 32px;\n          }\n        }\n      }\n    }\n  }\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  ", " {\n    padding: 0;\n    border: 0;\n    border-radius: 0;\n    box-shadow: none;\n    background-color: #f5f5f5;\n\n    .", "menu-header {\n      box-sizing: border-box;\n      border-bottom: 1px solid #ebebeb;\n      padding: 15px 0 14px;\n    }\n\n    ", " {\n      background-color: #f5f5f5;\n\n      .", "nav-item.", "menu-item {\n        background-color: #f5f5f5;\n        color: #555555;\n        padding: 0 16px 0 16px;\n\n        &:hover {\n          background-color: #ebebeb;\n          color: #111111;\n        }\n\n        &.", "opened {\n          color: #555555;\n        }\n\n        .", "menu-item-inner {\n          position: relative;\n          .", "menu-icon-arrow {\n            color: #a8a8a8;\n            right: 0;\n          }\n        }\n      }\n    }\n\n    ", " {\n      color: #555555;\n      background-color: #f5f5f5;\n      padding: 0 24px 0 16px;\n\n      &:hover {\n        background-color: #ebebeb;\n        color: #111111;\n      }\n\n      a {\n        color: #555555;\n        &:hover {\n          text-decoration: none;\n        }\n      }\n\n      &.", "nav-item.", "menu-item.", "selected.", "selected {\n        background-color: #dedede;\n        color: #333333;\n      }\n\n      &.", "nav-item.", "menu-item.", "disabled {\n        color: #c1c1c1;\n\n        a {\n          background-color: #f5f5f5;\n        }\n\n        &:hover {\n          background-color: #f5f5f5;\n          color: #c1c1c1;\n        }\n      }\n    }\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import React from 'react';
import styled from 'styled-components';
import { Nav } from '@alicloud/console-components';
import Item from './Item';
import SubMenu from './SubMenu';
import { getPriority } from '../utils';
/**
 * @public
 */

var PrimaryMenu = styled(NavFilterProps)(_templateObject(), getPriority(5), getPrefix, SubMenu, getPrefix, getPrefix, getPrefix, getPrefix, getPrefix, Item, getPrefix, getPrefix, getPrefix, getPrefix, getPrefix, getPrefix, getPrefix);
export default PrimaryMenu;
/**
 * @public
 */

export var SecondaryMenu = styled(NavFilterProps)(_templateObject2(), getPriority(5), Item, getPrefix, getPrefix, getPrefix, getPrefix, SubMenu, getPrefix, getPrefix, getPrefix, getPrefix, getPrefix, getPrefix, getPrefix, Item, getPrefix);

function getPrefix(_ref) {
  var fusionPrefix = _ref.fusionPrefix;
  return fusionPrefix;
}

function NavFilterProps(_ref2) {
  var fusionPrefix = _ref2.fusionPrefix,
      props = _objectWithoutProperties(_ref2, ["fusionPrefix"]);

  return React.createElement(Nav, props);
}